import React from 'react'
// libs
import { useSelector } from 'react-redux'
import { formValueSelector } from 'redux-form'
// hocs
import withAddForm from './withAddForm'
// hooks
import { useKeepInView } from 'hooks/useKeepInView'
// constants
import { TREE_SCROLL_CONTAINER_ID } from 'components/UI/TableTree/constants'
// components
import { ClickAwayListener } from '@mui/material'
import { ReduxInput } from 'components/FormElements/ReduxForm'
// views
import { AddButton, CloseIcon, Form } from './views'

const AddEntityForm = ({ form, handleClose, handleSubmit, label, marginLeft, paddingless, submit }) => {
  const selector = formValueSelector(form)

  // Brings the form into view when it opens, and keeps it there while the created item arrives.
  const formRef = useKeepInView(TREE_SCROLL_CONTAINER_ID)

  const { name } = useSelector((state) => ({
    name: selector(state, 'name')
  }))

  const handleClickAway = () => {
    if (name) {
      submit()
    }

    handleClose()
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      handleClose()
    }
  }

  React.useEffect(() => {
    const onKeyDown = (event) => {
      if (event.key === 'Escape') {
        handleClose()
      }
    }

    document.addEventListener('keydown', onKeyDown)
    return () => document.removeEventListener('keydown', onKeyDown)
  }, [handleClose])

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <Form
        ref={formRef}
        onSubmit={handleSubmit}
        marginLeft={marginLeft}
        paddingless={paddingless}
        onKeyDown={handleKeyDown}>
        <ReduxInput autoFocus name={'name'} placeholder={label} />
        <AddButton type={'submit'}>
          Add
        </AddButton>
        <CloseIcon onClick={handleClose} />
      </Form>
    </ClickAwayListener>
  )
}

// TODO: check
// Form names comes from props
export default withAddForm(AddEntityForm)
